import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import * as Auth from "../../../Login/Auth"
import { SingleInput, SingleRedio } from '../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_getModuleDetail, api_addModule } from '../../../../api/apiModule';
import { RespModuleItem, ReqModule, ReqModuleItem } from '../../../../item/ItemModule';
import { sortBy } from '../../../../item/ItemTools';


export function ModuleEdit({ id, setIsLoading }) {
  const [moduleId, setModuleId] = useState("")
  const [moduleName, setModuleName] = useState("")
  const [modulePages, setModulePages] = useState([])
  const [pages, setPages] = useState([])

  useEffect(() => {
    var module = Auth.getval2Token('module', id)
    // console.log(module)
    // console.log(module.moduleId)
    if (module !== undefined && module.moduleId !== undefined) {
      setModuleId(module.moduleId)
      setModuleName(module.moduleName)
      if (module.items.length > 0) {
        setModulePagesSort(module.items)
      } else {
        getDetial("")
      }
    } else {
      getDetial("")
    }
  }, [])

  // useEffect(() => {
  //   if (moduleId !== undefined && moduleId !== "") {
  //     getDetial(moduleId)
  //   }
  // }, [moduleId])

  useEffect(() => {
    // console.log(modulePages)
    if (modulePages.length > 0 && pages.length === 0) {
      getDetial("")
    }
  }, [modulePages])

  function checkPageInit(ps) {
    var todo = false;
    console.log(modulePages)
    var mps = JSON.parse(JSON.stringify(modulePages))
    if (mps !== undefined && pages.length > 0) {
      ps = pages
      todo = true
    } else if (ps !== undefined && mps.length > 0) {
      todo = true
    }

    if (todo) {
      // console.log(ps)
      mps.forEach(item => {
        // console.log(item)
        var filterEmpty = ps.filter((page) => {
          page.menuName = page.menuName3
          return page.pageId !== item.pageId;
        });
        ps = filterEmpty
        console.log(filterEmpty)
      })
    }
    setPagesSort(ps)
  }

  function getDetial(moduleId) {
    setIsLoading(true)
    var mReqModuleItem = new ReqModuleItem({ moduleId })
    api_getModuleDetail({
      mReqModuleItem,
      success: (jsonData) => {
        // console.log(jsonData)
        // if (jsonData.detail !== null) {
        //   var mRespModuleItem = new RespModuleItem({})
        //   mRespModuleItem.fromJson(jsonData.detail)

        //   setModuleName(mRespModuleItem.moduleName)
        //   setModulePages(mRespModuleItem.items)
        // }

        // console.log(modulePages)
        checkPageInit(jsonData.pages)
        // setPages(jsonData.pages)
        setIsLoading(false)
      },
      failure: (err) => {
        setIsLoading(false)
      }
    })
  }

  function toCancel() {
    window.history.back();
  }

  function toEdit() {
    if (moduleName !== "") {
      var mReqModule = new ReqModule({
        moduleId,
        moduleName,
        items: modulePages,
      })
      api_addModule({
        mReqModule,
        success: (jsonData) => {
          Swal.fire({
            type: 'success',
            title: '提醒',
            text: moduleId === "" ? '新增成功' : '編輯成功',
          }).then(function () {
            //window.history.replace("/ManagerList");
          })
        },
        failure: (err) => {
          Swal.fire({
            type: 'error',
            title: '提醒',
            text: err.message,
          })
        }
      })
    } else {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '類別名稱 不得為空',
      })
    }
  }


  function choose(val) {
    console.log('choose')
    var filterEmpty = pages.filter((page) => {
      //console.log(page)
      return page.pageId === val;
    });
    var list = modulePages.concat(filterEmpty[0])
    //console.log(list)
    filterEmpty = pages.filter((page) => {
      //console.log(page)
      return page.pageId !== val;
    });
    //console.log(filterEmpty)

    setPagesSort(filterEmpty)
    setModulePagesSort(list)
  }

  function unChoose(val) {
    console.log(unChoose)
    var filterEmpty = modulePages.filter((page) => {
      //console.log(page)
      return page.pageId === val;
    });
    var list = pages.concat(filterEmpty[0])
    //console.log(list)
    filterEmpty = modulePages.filter((page) => {
      //console.log(page)
      return page.pageId !== val;
    });
    //console.log(filterEmpty)

    setPagesSort(list)
    setModulePagesSort(filterEmpty)
  }

  function setPagesSort(list){
    // console.log(list)
    list.sort(sortBy('pageDescription', false, String))
    setPages(list)
  }

  function setModulePagesSort(list){
    console.log(list)
    list.sort(sortBy('pageDescription', false, String))
    setModulePages(list)
  }

  var title = <>模組{moduleId === "" ? "新增" : "編輯"}</>
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <SingleInput title={"名稱"} val={moduleName} action={setModuleName} placeholder={"外部員工、薪資計算"} size={4} />

        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <h3>已擁有權限頁面</h3>
          <select className="form-control" multiple="multiple" size="10">
            {
              modulePages.map((page, index) => (
                <option key={page.pageId + index} value={page.pageId} onClick={e => unChoose(e.target.value)}>[{page.menuName}]{page.pageName}[{page.pageLink}][{page.pageDescription}]</option>
              ))
            }
          </select>
        </div>
        <Space />
        <Space />
        <div className="col-md-12">
          <h3>可選擇之頁面</h3>
          <select className="form-control" multiple="multiple" size="10">
            {
              pages.map((page, index) => (
                <option key={page.pageId + index} value={page.pageId} onClick={e => choose(e.target.value)}>[{page.menuName}]{page.pageName}[{page.pageLink}][{page.pageDescription}]</option>
              ))
            }
          </select>
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      <div className="col-sm-3 col-sm-offset-9">
        <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={toEdit} isRight={true} />
      </div>
    </div>

  return (
    <>
      <ContentBox title={title} content={content} footer={footer} hasDrawer={true} />
      <SystemPromptInput />
    </>
  )
}